import { makeAutoObservable } from 'mobx'
import Cookies from 'js-cookie'

import { LOCALES } from '../i18n/locales'
import { XImage } from '../models/XImage'
import { IXProject } from '../models/XProject'
import { HomeMenuPage, StorageKeys } from '../utils/defaults'
import { ApiService } from '../../core/api/api'

export default class Store {
	isAuth = false
	token: string = ''
	userData: any = {}
	locale: string = LOCALES.RUSSIAN
	theme: string = 'winter'

	isActiveA: boolean = false
	portfolioRendered: boolean = false

	isBackCallVisible: boolean = false
	isMobile: boolean = false
	isMenuOpenned: boolean = false
	isFaderVisible: boolean = true
	isFaderShown: boolean = true
	isFaderLogo: boolean = false
	isContentShown: boolean = false
	isHomeBlockVisible: boolean = false

	xScr: number = 50

	headerTheme: string = ''

	isHeaderLocked: boolean = false
	selectedSlide: number = 0

	menuSelected: number = 0

	refuseDrop: boolean = false

	selectedIx: number = 0
	selectedIxSPA: number = 0
	selectedIxResto: number = 0
	selectedIxEntert: number = 0
	allRooms: any[] = []
	allSPA: any[] = []
	allResto: any[] = []
	allEntert: any[] = []
	allEntertItems: any[] = []

	isImageViewVisible: boolean = false
	selectedImages: XImage[] = []
	selectedImageIndex: number = 0

	videoInit: number = 0

	nextProject: IXProject | null = null
	selectedProject: IXProject | null = null
	selectedProjectImgs: any[] = []

	projectTiles: number = 0
	projectTilts: number = 0

	isSlideActive: boolean = true
	isSliderInited: boolean = false
	slideIndex: number = 0

	mouseEntered: boolean = false

	activeSl: string = ''

	formTitle: string = ''
	isFormVisible: boolean = false

	inter: null | any = null
	interTimes: number = 0
	interState: number = 0
	interStateX: number = 0

	dpDpShown: boolean = false
	dpAccShown: boolean = false

	techworksState: boolean = false
	techworksSetting: any | null = null

	isSettingsLoaded: boolean = false
	isSettingsPreloaded: boolean = false

	translations: any = {}
	transAll: any[] = []
	locales: any[] = []

	services: any[] = []

	constructor() {
		makeAutoObservable(this)
	}

	setServices(val: any[]) {
		this.services = val
	}

	setHeaderTheme(val: string) {
		this.headerTheme = val
	}

	setLocales(val: any[]) {
		this.locales = val
	}

	setTransAll(trans: any[]) {
		this.transAll = trans
	}

	setTranslations(val: any) {
		this.translations = val
	}

	setIsSettingsPreloaded(val: boolean) {
		this.isSettingsPreloaded = val
	}

	setIsSettingsLoaded(val: boolean) {
		this.isSettingsLoaded = val
	}

	setTechworksSetting(val: any) {
		this.techworksSetting = val
	}

	setTechworksState(val: boolean) {
		this.techworksState = val
	}

	setDpDpShown(val: boolean) {
		this.dpDpShown = val
	}

	setDpAccShown(val: boolean) {
		this.dpAccShown = val
	}

	setInterTimes(val: number) {
		this.interTimes = val
	}

	setInterState(val: number) {
		this.interState = val
	}

	setInterStateX(val: number) {
		this.interStateX = val
	}

	setInter(val: any) {
		this.inter = val
	}

	setFormTitle(val: string) {
		this.formTitle = val
	}

	setIsFormVisible(val: boolean) {
		this.isFormVisible = val
	}

	setActiveSl(sl: string) {
		this.activeSl = sl
	}

	setMouseEntered(val: boolean) {
		this.mouseEntered = val
	}

	setIsSliderInited(val: boolean) {
		this.isSliderInited = val
	}

	setIsSlideActive(val: boolean) {
		this.isSlideActive = val
	}

	setSlideIndex(val: number) {
		this.slideIndex = val
	}

	setProjectTilts(val: number) {
		this.projectTilts = val
	}

	setProjectTiles(val: number) {
		this.projectTiles = val
	}

	setLocale(val: any) {
		localStorage.setItem('mainburo_lang', val)
		this.locale = val
	}

	setSelectedProject(val: IXProject | null) {
		this.selectedProject = val
	}

	setNextProject(val: IXProject | null) {
		this.nextProject = val
	}

	setSelectedProjectImgs(val: any) {
		this.selectedProjectImgs = val
	}

	setTheme(val: string) {
		this.theme = val
	}

	setVideoInit(val: number) {
		this.videoInit = val
	}

	setIsImageViewVisible(val: boolean) {
		this.isImageViewVisible = val
	}

	setSelectedImageIndex(val: number) {
		this.selectedImageIndex = val
	}

	setSelectedImages(val: XImage[]) {
		this.selectedImages = val
	}

	setAllRooms(val: any[]) {
		this.allRooms = val
	}

	setAllSPA(val: any[]) {
		this.allSPA = val
	}

	setAllEntert(val: any[]) {
		this.allEntert = val
	}

	setAllEntertItems(val: any[]) {
		this.allEntertItems = val
	}

	setSelectedIxEntert(val: number) {
		this.selectedIxEntert = val
	}

	setAllResto(val: any[]) {
		this.allResto = val
	}

	setSelectedIxResto(val: number) {
		this.selectedIxResto = val
	}

	setSelectedIxSPA(val: number) {
		this.selectedIxSPA = val
	}

	setSelectedIx(val: number) {
		this.selectedIx = val
	}

	setRefuseDrop(bl: boolean) {
		this.refuseDrop = bl
	}

	setSelectedSlide(bl: number) {
		this.selectedSlide = bl
	}

	setIsHomeBlockVisible(bl: boolean) {
		this.isHomeBlockVisible = bl
	}

	setMenuSelected(item: number) {
		this.menuSelected = item
	}

	setIsHeaderLocked(bl: boolean) {
		this.isHeaderLocked = bl
	}

	setIsBackCallVisible(bl: boolean) {
		this.isBackCallVisible = bl
	}

	setIsContentShown(bl: boolean) {
		this.isContentShown = bl
	}

	setIsMobile(bl: boolean) {
		this.isMobile = bl
	}

	setIsMenuOpenned(bl: boolean) {
		this.isMenuOpenned = bl
	}

	setIsFaderVisible(bl: boolean) {
		this.isFaderVisible = bl
	}

	setIsFaderShown(bl: boolean) {
		this.isFaderShown = bl
	}

	setIsFaderLogo(bl: boolean) {
		this.isFaderLogo = bl
	}

	setIsAuth(val: boolean) {
		this.isAuth = val
	}

	setToken(val: string) {
		this.token = val
	}

	setUserData(val: any) {
		this.userData = val
	}

	clearUserAuth() {
		this.token = ''
		this.userData = {}
		this.isAuth = false
		localStorage.removeItem(StorageKeys.USER)
		localStorage.removeItem(StorageKeys.TOKEN)
		localStorage.removeItem(StorageKeys.AUTHED)
	}

	async checkAuth(validateServer = false) {
		const user = localStorage.getItem(StorageKeys.USER)
		const token = localStorage.getItem(StorageKeys.TOKEN)
		if (!user || !token) {
			this.clearUserAuth()
			return false
		}

		try {
			if (validateServer) {
				const res = await ApiService.users.getAccount()
				if (res?.data?.state !== 1 || !res.data.user) {
					this.clearUserAuth()
					return false
				}
				this.userData = res.data.user
				this.isAuth = true
				this.token = token
				localStorage.setItem(StorageKeys.USER, JSON.stringify(res.data.user))
				return true
			}

			this.userData = JSON.parse(user)
			this.isAuth = true
			this.token = token
			return true
		} catch {
			this.clearUserAuth()
			return false
		}
	}

	setupAuth(token: string, user: any) {
		localStorage.setItem(StorageKeys.AUTHED, '1')
		localStorage.setItem(StorageKeys.TOKEN, token)
		localStorage.setItem(StorageKeys.USER, JSON.stringify(user))
		this.token = token
		this.userData = user
		this.isAuth = true
	}

	applyAuth(token: string, user: any) {
		localStorage.setItem(StorageKeys.AUTHED, '1')
		localStorage.setItem(StorageKeys.TOKEN, token)
		localStorage.setItem(StorageKeys.USER, JSON.stringify(user))
		this.token = token
		this.userData = user
		this.isAuth = true
	}

	async logout() {
		this.clearUserAuth()
		try {
			await ApiService.users.logout()
		} catch {}
	}
}
